import lazyWithPreload from 'react-lazy-with-preload';

const LoadingMenuScreenLazy = lazyWithPreload(
  () => import('./loading-menu-screen')
);

export { LoadingMenuScreenLazy };
